// @flow
import getEndpointUrl from 'api/getEndpointUrl';
import checkResponse from 'api/checkIfResponseIsOK';
import wrapWithNetworkError from 'api/wrapWithNetworkError';

const getAppConfig = wrapWithNetworkError(function _getAppConfig(token) {
  const fetchUrl = getEndpointUrl('/getAppConfig');
  const fetchOptions = {
    headers: {
      Authorization: token,
    },
  };

  return fetch(fetchUrl, fetchOptions)
    .then(response => checkResponse(response))
    .then(response => response.json());
});

export default getAppConfig;



// WEBPACK FOOTER //
// ./src/api/getAppConfig.js